var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line Rounded/Email"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3334 6.07129V14.4046C18.3334 14.9572 18.1139 15.4871 17.7232 15.8778C17.3325 16.2685 16.8026 16.488 16.2501 16.488H3.75008C3.19755 16.488 2.66764 16.2685 2.27694 15.8778C1.88624 15.4871 1.66675 14.9572 1.66675 14.4046V6.07129",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3334 6.07161C18.3334 5.51908 18.1139 4.98918 17.7232 4.59848C17.3325 4.20777 16.8026 3.98828 16.2501 3.98828H3.75008C3.19755 3.98828 2.66764 4.20777 2.27694 4.59848C1.88624 4.98918 1.66675 5.51908 1.66675 6.07161L8.89591 10.5855C9.22702 10.7924 9.60962 10.9022 10.0001 10.9022C10.3905 10.9022 10.7731 10.7924 11.1042 10.5855L18.3334 6.07161Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.39e11347169ac6af7e706eaceca87fd2.svg";
export { ForwardRef as ReactComponent };